<div class="assign-people-dialog-wrapper">
  <mat-dialog-content class="min-h-[10rem]">
    <ng-container *ngIf="ready$ | async; else checkoutLoading">
      <app-extra-job-checkout
        *ngIf="data.extraJob"
        [extraJob]="data.extraJob"
        [shouldRedirect]="false"
      ></app-extra-job-checkout>
      <app-job-checkout
        *ngIf="!data.extraJob && data.job"
        [job]="data.job"
        [shouldRedirect]="false"
      ></app-job-checkout>
    </ng-container>

    <ng-template #checkoutLoading>
      <div class="flex min-h-[10rem] items-center justify-center">
        <mat-spinner diameter="36"></mat-spinner>
      </div>
    </ng-template>
  </mat-dialog-content>
</div>
